import { render } from "./EditFollowupAssessment.vue?vue&type=template&id=55440c54&scoped=true"
import script from "./EditFollowupAssessment.vue?vue&type=script&lang=js"
export * from "./EditFollowupAssessment.vue?vue&type=script&lang=js"

import "./EditFollowupAssessment.vue?vue&type=style&index=0&id=55440c54&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55440c54"]])

export default __exports__